import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import { UserConsumer } from "../../../UserContext";
import paginationFactory, {
    PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Table } from "../../../components/CustomPaginations";
import { tableStyle } from "../../../components/TableStyle";
import { ResourceLeavesInfo_API } from "./ResourceLeavesInfo_API";
import Header from "../../../components/Header";
import CustomeSearchBar from "../../../components/CustomeSearchBar";
import {
    GlobalPaginationSize,
    getPaginationSizeOnRole,
} from "../../../components/GlobalPaginationSize";
import { Routes } from "../../../configurations/config";
import ButtonLoader from "../../../components/ButtonLoader";
import {
    ExcelBtnClassName,
    ExcelBtnTitle,
} from "../../ticketModule/variables/ListingVariables";

function EmployeeLeaveInfoListing() {
    let token,
        empDesignation = null;
    let history = useHistory();

    const defaultSorted = [
        {
            dataField: "employeeName",
            order: "desc",
        },
    ];
    const itemReqDepartmentIds = ["3", "5", "9"]; // To which review Item Requisition should be shown// SSN,accounts,admin
    const [searchInput, setSearchInput] = useState(null);
    const [pagerData, setPagerData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [apiHeaderToken, setApiHeaderToken] = useState(null);
    const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
        GlobalPaginationSize.defaultPaginationSize
    );
    const [employeeLeavesData, setEmployeeLeavesData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [sortBy, setSortBy] = useState(defaultSorted[0]);

    const getColumns = [
        {
            dataField: "employeeName",
            text: "Employee Name",
            sort: true,
        },
        {
            dataField: "sickLeave",
            text: "Sick",
            sort: true,
        },
        {
            dataField: "annualLeave",
            text: "Annual",
            sort: true,
        },
        {
            dataField: "compansationLeave",
            text: "Compensation",
            sort: true,
        },
        {
            dataField: "maternityLeave",
            text: "Maternity",
            sort: true,
        },
        {
            dataField: "withoutPayLeave",
            text: "Without Pay",
            sort: true,
        },
        {
            dataField: "action",
            text: "Action",

            formatter: (cell, row) => {
                return (
                    <div>
                        <Link
                            to={{
                                pathname: `${Routes.ResourceLeavesInfo}${row.employeeID}`,
                                state: {
                                    employeeLeaveListingRedirection: true,
                                },
                            }}
                        >
                            <button className="btnStyle" title="View Detail">
                                <FontAwesomeIcon
                                    id="edit"
                                    className="hoverEffect"
                                    icon={faEye}
                                    size="1x"
                                />
                            </button>
                        </Link>
                    </div>
                );
            },
        },
    ];
    useEffect(() => {
        const pageSize = getPaginationSizeOnRole(empDesignation);
        setNumberOfItemsPerPage(pageSize);

        const apiHeaderToken = {
            Authorization: `Bearer ${token}`,
        };
        setApiHeaderToken(apiHeaderToken);
        axios
            .get(
                `${
                    ResourceLeavesInfo_API.GetEmployeesListLeaves
                }?PageNumber=${1}&PageSize=${pageSize}&SortBy=${
                    sortBy.dataField
                }_${sortBy.order}`,
                {
                    headers: apiHeaderToken,
                }
            )
            .then((res) => {
                if (res.status === 200) {
                    setIsLoading(false);
                    setPagerData(JSON.parse(res.headers["x-pagination"]));
                    setEmployeeLeavesData(res.data.leaveInfo);
                }
            });
    }, []);

    const receiveData = (PageSize) => {
        setIsLoading(true);
        let apiURL = "";
        if (searchInput === "" || searchInput === null)
            apiURL = `${
                ResourceLeavesInfo_API.GetEmployeesListLeaves
            }?PageNumber=${1}&PageSize=${PageSize}&SortBy=${sortBy.dataField}_${
                sortBy.order
            }`;
        else
            apiURL = `${
                ResourceLeavesInfo_API.GetEmployeesListLeaves
            }?PageNumber=${1}&PageSize=${PageSize}&SortBy=${sortBy.dataField}_${
                sortBy.order
            }&SearchTerm=${searchInput}`;

        axios
            .get(apiURL, {
                headers: apiHeaderToken,
            })
            .then((res) => {
                if (res.status === 200) {
                    setIsLoading(false);
                    setPageNum(1);
                    setNumberOfItemsPerPage(PageSize);
                    setPagerData(JSON.parse(res.headers["x-pagination"]));
                    setEmployeeLeavesData(res.data.leaveInfo);
                }
            });
    };
    const handleTableChange = (type, { page, sortOrder, sortField }) => {
        setIsLoading(true);
        let getData = false;
        let apiURL = "";

        if (type === "sort") {
            apiURL = `${ResourceLeavesInfo_API.GetEmployeesListLeaves}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortField}_${sortOrder}`;
            setSortBy({ dataField: sortField, order: sortOrder });
            getData = true;
        } else if (type === "pagination") {
            apiURL = `${ResourceLeavesInfo_API.GetEmployeesListLeaves}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortBy.dataField}_${sortBy.order}`;
            getData = true;
        }
        if (getData) {
            axios
                .get(apiURL, {
                    headers: apiHeaderToken,
                })
                .then((res) => {
                    if (res.status === 200) {
                        setIsLoading(false);
                        setPagerData(JSON.parse(res.headers["x-pagination"]));
                        setEmployeeLeavesData(res.data.leaveInfo);
                    }
                });
        }
    };

    const exportToExcel = (e) => {
        e.preventDefault();
        setIsLoading(true);

        axios
            .get(
                `${
                    ResourceLeavesInfo_API.EmployeesListLeavesExportToExcel
                }`,
                {
                    headers: apiHeaderToken,
                    responseType: "blob",
                }
            )
            .then((response) => {
                const url = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    "ResourceLeaveInfo.xlsx"
                );
                document.body.appendChild(link);
                link.click();
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            });
    };
    const handleSearch = (event) => {
        setIsLoading(true);
        const value = event.target.value;
        setSearchInput(value);

        let apiUrl = null;

        if (value === "")
            apiUrl = `${
                ResourceLeavesInfo_API.GetEmployeesListLeaves
            }?PageNumber=${1}&PageSize=${numberOfItemsPerPage}&SortBy=${
                sortBy.dataField
            }_${sortBy.order}`;
        else
            apiUrl = `${
                ResourceLeavesInfo_API.GetEmployeesListLeaves
            }?PageNumber=${1}&PageSize=${numberOfItemsPerPage}&SortBy=${
                sortBy.dataField
            }_${sortBy.order}&SearchTerm=${value}`;

        axios
            .get(apiUrl, {
                headers: apiHeaderToken,
            })
            .then((res) => {
                if (res.status === 200) {
                    setIsLoading(false);
                    setPagerData(JSON.parse(res.headers["x-pagination"]));
                    setEmployeeLeavesData(res.data.leaveInfo);
                }
            });
    };
    const rowEvents = {
        onClick: (e, row) => {
            history.push({
                pathname: `${Routes.ResourceLeavesInfo}${row.employeeID}`,
                state: {
                    employeeLeaveListingRedirection: true,
                },
            });
        },
    };
    return (
        <UserConsumer>
            {(userDetails) => {
                token = userDetails.token;
                empDesignation = userDetails.designation;
                return itemReqDepartmentIds.includes(
                    userDetails.department.toString()
                ) ||
                    userDetails.empRole.includes("2") ||
                    userDetails.designation.toString() === "4" ||
                    userDetails.designation.toString() === "5" ? (
                    <>
                        <div className="container-fluid pl-3 pr-3">
                            <Header
                                title="Employees Leaves Info"
                                headerBorder="false"
                            />

                            <CustomeSearchBar
                                handleSearch={(event) => handleSearch(event)}
                                tooltip={"Search by Employee Name"}
                            />
                            <div className="d-flex">
                                <ButtonLoader
                                    className={ExcelBtnClassName}
                                    onClick={exportToExcel}
                                    btnTitle={ExcelBtnTitle}
                                    showBtnLoading={isLoading}
                                    disabled={
                                        !employeeLeavesData.length ||
                                        isLoading ||
                                        (searchInput !== null && searchInput.trim() !== '')
                                    }
                                />
                            </div>
                            <PaginationProvider
                                pagination={paginationFactory({
                                    custom: true,
                                    totalSize: pagerData
                                        ? pagerData.TotalCount
                                        : 0,
                                    page: pageNum,
                                    sizePerPage: numberOfItemsPerPage,
                                    paginationSize: numberOfItemsPerPage,
                                })}
                            >
                                {({
                                    paginationProps,
                                    paginationTableProps,
                                }) => {
                                    return (
                                        <Table
                                            inputValue={searchInput}
                                            keyField={"employeeID"}
                                            columns={getColumns}
                                            items={employeeLeavesData}
                                            tableStyle={tableStyle}
                                            paginationProps={paginationProps}
                                            paginationTableProps={
                                                paginationTableProps
                                            }
                                            onTablePageChange={
                                                handleTableChange
                                            }
                                            defaultSorted={defaultSorted}
                                            showFeedback={false}
                                            tableLoader={isLoading}
                                            SearchBar={() => {
                                                return null;
                                            }}
                                            pagerData={pagerData}
                                            receiveData={(PageSize) => {
                                                receiveData(PageSize);
                                            }}
                                            rowEvents={rowEvents}
                                        />
                                    );
                                }}
                            </PaginationProvider>
                        </div>
                    </>
                ) : (
                    <Redirect to="/MyDashboard" />
                );
            }}
        </UserConsumer>
    );
}

export default EmployeeLeaveInfoListing;
